import { useToastStore } from '@/store/toastStore';

/**
 * 일반 토스트 렌더러.
 * App 루트 (DefaultLayout 바깥) 에 1회 마운트.
 */
export function Toaster() {
  const toasts = useToastStore((s) => s.toasts);

  if (toasts.length === 0) return null;

  return (
    <div
      className="pointer-events-none fixed inset-x-0 bottom-20 z-[60] flex flex-col items-center gap-2"
      role="region"
      aria-live="polite"
    >
      {toasts.map((t) => {
        /* success / error / default(info) 모두 primary 계열 중심.
           토스 스타일: 단일 강조색 + 상태는 아이콘/문구로만 구분. */
        const cls =
          t.kind === 'error'
            ? 'bg-[var(--color-rise)] text-white'
            : 'bg-[var(--color-primary)] text-[var(--color-primary-inv)]';
        return (
          <div
            key={t.id}
            className={`pointer-events-auto max-w-[92vw] rounded-full px-4 py-2 text-xs font-medium shadow-lg ${cls}`}
          >
            {t.message}
          </div>
        );
      })}
    </div>
  );
}
